import React from "react";
import "./Popup.css";

const ErrorPopup = ({ message, onClose }) => (
  <div className='popup-backdrop'>
    <div className='popup error'>
      <h4>Error</h4>
      <p>{message}</p>
      <button onClick={onClose}>Close</button>
    </div>
  </div>
);

export default ErrorPopup;
